import { createRouter, createWebHistory } from 'vue-router';
import CompanyView from '@/views/content/Company.vue';
import ProductEditView from '@/views/product/Edit.vue';
const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/auth/Login.vue'),
        meta: { title: '登录' }
    },
    {
        path: '/',
        name: 'Layout',
        component: () => import('@/components/Layout.vue'),
        redirect: '/dashboard',
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () => import('@/views/dashboard/Index.vue'),
                meta: { title: '数据概览', requiresAuth: true }
            },
            {
                path: '/product',
                name: 'Product',
                redirect: '/product/list',
                meta: { title: '商品管理', requiresAuth: true },
                children: [
                    {
                        path: '/product/list',
                        name: 'ProductList',
                        component: () => import('@/views/product/List.vue'),
                        meta: { title: '商品列表', requiresAuth: true }
                    },
                    {
                        path: '/product/add',
                        name: 'ProductAdd',
                        component: ProductEditView,
                        meta: { title: '添加商品', requiresAuth: true }
                    },
                    {
                        path: '/product/edit/:id',
                        name: 'ProductEdit',
                        component: ProductEditView,
                        meta: { title: '编辑商品', requiresAuth: true }
                    },
                    {
                        path: '/product/category',
                        name: 'ProductCategory',
                        component: () => import('@/views/product/Category.vue'),
                        meta: { title: '商品分类', requiresAuth: true }
                    }
                ]
            },
            {
                path: '/order',
                name: 'Order',
                redirect: '/order/list',
                meta: { title: '订单管理', requiresAuth: true },
                children: [
                    {
                        path: '/order/list',
                        name: 'OrderList',
                        component: () => import('@/views/order/List.vue'),
                        meta: { title: '订单列表', requiresAuth: true }
                    },
                    {
                        path: '/order/detail/:id',
                        name: 'OrderDetail',
                        component: () => import('@/views/order/Detail.vue'),
                        meta: { title: '订单详情', requiresAuth: true }
                    },
                    {
                        path: '/order/return',
                        name: 'OrderReturn',
                        component: () => import('@/views/order/Return.vue'),
                        meta: { title: '售后管理', requiresAuth: true }
                    }
                ]
            },
            {
                path: '/review/manage',
                name: 'ReviewManage',
                component: () => import('@/views/review/Index.vue'),
                meta: { title: '评价管理', requiresAuth: true }
            },
            {
                path: '/user',
                name: 'User',
                redirect: '/user/list',
                meta: { title: '用户管理', requiresAuth: true },
                children: [
                    {
                        path: '/user/list',
                        name: 'UserList',
                        component: () => import('@/views/user/List.vue'),
                        meta: { title: '用户列表', requiresAuth: true }
                    }
                ]
            },
            {
                path: '/distribution',
                name: 'Distribution',
                redirect: '/distribution/audit',
                meta: { title: '分销管理', requiresAuth: true },
                children: [
                    {
                        path: '/distribution/audit',
                        name: 'DistributionAudit',
                        component: () => import('@/views/distribution/Audit.vue'),
                        meta: { title: '区域经理审核', requiresAuth: true }
                    },
                    {
                        path: '/distribution/performance',
                        name: 'DistributionPerformance',
                        component: () => import('@/views/distribution/Performance.vue'),
                        meta: { title: '业绩查看', requiresAuth: true }
                    }
                ]
            },
            {
                path: '/content',
                name: 'Content',
                redirect: '/content/banner',
                meta: { title: '内容管理', requiresAuth: true },
                children: [
                    {
                        path: '/content/banner',
                        name: 'ContentBanner',
                        component: () => import('@/views/content/Banner.vue'),
                        meta: { title: '轮播图管理', requiresAuth: true }
                    },
                    {
                        path: '/content/company',
                        name: 'ContentCompany',
                        component: CompanyView,
                        meta: { title: '公司介绍', requiresAuth: true }
                    },
                    {
                        path: '/content/home-categories',
                        name: 'ContentHomeCategories',
                        component: () => import('@/views/content/CategoryHome.vue'),
                        meta: { title: '首页分类展示', requiresAuth: true }
                    }
                ]
            },
            {
                path: '/settings',
                name: 'Settings',
                redirect: '/settings/basic',
                meta: { title: '系统设置', requiresAuth: true },
                children: [
                    {
                        path: '/settings/basic',
                        name: 'SettingsBasic',
                        component: () => import('@/views/settings/Basic.vue'),
                        meta: { title: '基本信息', requiresAuth: true }
                    },
                    {
                        path: '/settings/commission',
                        name: 'SettingsCommission',
                        component: () => import('@/views/settings/Commission.vue'),
                        meta: { title: '提成设置', requiresAuth: true }
                    },
                    {
                        path: '/settings/discount',
                        name: 'SettingsDiscount',
                        component: () => import('@/views/settings/Discount.vue'),
                        meta: { title: '折扣设置', requiresAuth: true }
                    },
                    {
                        path: '/settings/logistics',
                        name: 'SettingsLogistics',
                        component: () => import('@/views/settings/Logistics.vue'),
                        meta: { title: '物流设置', requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});
// 路由守卫
router.beforeEach((to, _from, next) => {
    const token = localStorage.getItem('admin_token');
    if (to.meta.requiresAuth && !token) {
        next('/login');
    }
    else if (to.path === '/login' && token) {
        next('/dashboard');
    }
    else {
        next();
    }
});
export default router;
